import { Alert, Button, LinearProgress } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AsyncHelper(props) { if (props.loading) {
    return /*#__PURE__*/ _jsx(LinearProgress, { variant: "indeterminate" });
} if (props.error || !props.result) {
    return /*#__PURE__*/ _jsxs(Alert, { color: "error", children: [/*#__PURE__*/ _jsx("div", { children: props.error || "No Data" }), /*#__PURE__*/ _jsx("div", { children: /*#__PURE__*/ _jsx(Button, { onClick: () => props.reload(), children: "Retry" }) })] });
} return props.children(props.result); }
